import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import {
  TFinanceApiResponse,
  FinanceListParams,
} from '../../../../apis/finance/finance.interfaces';
import { useFinanceService } from '../../../../apis/finance/useFinanceService';

type TQueryError = IFHError<{ message: string }>;
export const getFinanceListKey = 'get-finance-list';

export const useFinanceListHook = (
  params: FinanceListParams,
  options?: UseQueryOptions<TFinanceApiResponse, TQueryError>
): UseQueryResult<TFinanceApiResponse, TQueryError> => {
  const { getFinanceList } = useFinanceService();

  return useQuery<TFinanceApiResponse, TQueryError>({
    queryKey: [getFinanceListKey, params],
    queryFn: () => getFinanceList(params),
    enabled: true,
    ...options,
  });
};

